<template>
    <div>
        <v-container>
            <v-simple-table style="border:solid,1px;padding:4px">
                <thead>
                    <tr>
                        <th style="font-size:20px">Tid</th>
                        <th style="font-size:20px">Kommentarer</th>
                        <th v-for="date in dates" :key="date.id">
                            <p
                                style="font-size:20px;color:white;background-color:orange;max-width:130px;border-radius:5px;padding:2px"
                            >
                                {{ toDDMMYY(date.schedule_date) }}
                            </p>
                            <p>
                                {{ toMMHH(date.time_from) }} to
                                {{ toMMHH(date.time_to) }}
                            </p>
                        </th>
                        <th
                            v-for="det in contact"
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            :key="det"
                        >
                            {{ det }}
                        </th>
                    </tr>

                    <tr>
                        <th style="font-size:15px">Deltagarens namn</th>
                    </tr>
                    <tr
                        v-show="schedule[0].hidden_schedule === 'no'"
                        v-for="participant in participation_table"
                        :key="participant.id"
                    >
                        <td>{{ participant.name }}</td>
                        <td>{{ participant.comment }}</td>
                        <td v-for="date in participant.dates" :key="date.id">
                            <p v-if="date.status == 1">
                                <v-icon style="margin-left:10px;color:green"
                                    >fas fa-check</v-icon
                                >
                            </p>
                            <p v-else>
                                <v-icon style="margin-left:10px;color:red"
                                    >fas fa-times</v-icon
                                >
                            </p>
                            <p>{{ date.comment }}</p>
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci0 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci1 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci2 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci3 }}
                        </td>
                        <td v-show="schedule[0].ask_for_contact == 'yes'">
                            {{ participant.ci4 }}
                        </td>
                    </tr>
                    <tr v-if="schedule[0].one_answer == 'no' && !datePassed()">
                        <td>
                            <v-text-field
                                v-model="name"
                                placeholder="ditt namn"
                                required
                            />
                        </td>
                        <td>
                            <v-text-field
                                v-model="comment"
                                placeholder="Kommentar"
                                required
                            />
                        </td>
                        <td v-for="(date, i) in selectedDates" :key="date.id">
                            <v-checkbox v-model="date.status" />
                            <v-row
                                ><v-text-field
                                    label="Comments"
                                    v-model="dateComments[i].comment"
                                />
                            </v-row>
                        </td>
                        <td
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            v-for="(det, i) in contact"
                            :key="det"
                        >
                            <v-text-field :label="det" v-model="ci[i]" />
                        </td>
                        <td>
                            <v-btn
                                style="background-color:#ffa500;margin-bottom:20px"
                                @click="submit"
                                >Sända
                                <v-icon style="margin-left:3px;font-size:15px">
                                    fas fa-check</v-icon
                                ></v-btn
                            >
                        </td>
                    </tr>

                    <tr
                        v-if="
                            !alreadyReplied() &&
                                schedule[0].one_answer == 'yes' &&
                                !datePassed()
                        "
                    >
                        <td>
                            <v-text-field
                                v-model="name"
                                placeholder="ditt namn"
                                required
                            />
                        </td>
                        <td>
                            <v-text-field
                                v-model="comment"
                                placeholder="Kommentar"
                                required
                            />
                        </td>
                        <td v-for="(date, i) in selectedDates" :key="date.id">
                            <v-checkbox v-model="date.status" />
                            <v-row
                                ><v-text-field
                                    label="Comments"
                                    v-model="dateComments[i].comment"
                                />
                            </v-row>
                        </td>
                        <td
                            v-show="det && schedule[0].ask_for_contact == 'yes'"
                            v-for="(det, i) in contact"
                            :key="det"
                        >
                            <v-text-field :label="det" v-model="ci[i]" />
                        </td>
                        <td>
                            <v-btn
                                style="background-color:#ffa500;margin-bottom:20px"
                                @click="submit"
                                >Sända
                                <v-icon style="margin-left:3px;font-size:15px">
                                    fas fa-check</v-icon
                                ></v-btn
                            >
                        </td>
                    </tr>
                    <tr
                        v-if="
                            schedule[0].one_answer == 'yes' && alreadyReplied()
                        "
                    >
                        <td style="text-align:center" colspan="5">
                            {{alreadyReplied()}}
                            Du har redan svarat för det här schemat
                        </td>
                    </tr>
                    <tr v-if="datePassed()">
                        <td style="text-align:center" colspan="5">
                            Svardatum för schemat passeras
                        </td>
                    </tr>
                </thead>
            </v-simple-table>
        </v-container>
        <v-container
            style="text-align:center;border:1px solid;max-width:700px;margin-top:10px"
        >
            <h4>Alla med länken kan rösta - inget konto behövs</h4>
            <br />
            <p>
                {{ copyLink() }}
                <v-btn v-clipboard="copyLink" text>
                    <v-icon>fas fa-copy</v-icon>
                </v-btn>
            </p>
        </v-container>
    </div>
</template>

<script>
export default {
    props: ["store"],
    data: function() {
        return {
            schedule: {},
            dates: [],
            participants: [],
            participant_dates: [],
            participation_table: [],
            name: "",
            selectedDates: [],
            comment: "",
            email: null,
            phone: null,
            shareLink: "",
            dateComment: "",
            dateComments: [],
            contact: [],
            ci: []
        };
    },
    async created() {
        (this.schedule = this.store.state.getSchedule.details),
            (this.dates = this.store.state.getSchedule.dates),
            (this.participants = this.store.state.getSchedule.participants),
            (this.participant_dates = this.store.state.getSchedule.participantDates);
        this.shareLink = `https://tid.nu/schedule/${this.schedule[0].schedule_link}`;
        for (var i = 0; i < this.participants.length; i++) {
            var participant = {
                id: i,
                name: this.participants[i].name,
                comment: this.participants[i].comment,
                dates: [],
                ci0: this.participants[i].ci0,
                ci1: this.participants[i].ci1,
                ci2: this.participants[i].ci2,
                ci3: this.participants[i].ci3,
                ci4: this.participants[i].ci4
            };
            for (var j = 0; j < this.participant_dates.length; j++) {
                if (
                    this.participants[i].id ===
                    this.participant_dates[j].participant_id
                )
                    participant.dates.push({
                        date: this.participant_dates[j].id,
                        status: this.participant_dates[j].participant_status,
                        comment: this.participant_dates[j].comment
                    });
            }
            this.participation_table = [
                ...this.participation_table,
                participant
            ];
            participant = { id: 0, name: "", dates: [] };
        }
        for (i = 0; i < this.dates.length; i++) {
            this.selectedDates[i] = { id: this.dates[i].id, status: false };
        }
        this.selectedDates.forEach(date => {
            this.dateComments.push({ id: date.id, comment: "" });
        });
        this.contact = [
            this.schedule[0].contact_info1,
            this.schedule[0].contact_info2,
            this.schedule[0].contact_info3,
            this.schedule[0].contact_info4,
            this.schedule[0].contact_info5
        ];
    },
    methods: {
        submit: async function() {
            let bodyFormData = new FormData();
            await bodyFormData.append(
                "dates",
                JSON.stringify({ dates: this.selectedDates })
            );
            await bodyFormData.append(
                "schedule_id",
                this.store.state.getSchedule.details[0].id
            );
            if (this.store.state.user.id)
                await bodyFormData.append("user_id", this.store.state.user.id);
            else await bodyFormData.append("user_id", 0);
            await bodyFormData.append("name", this.name);
            await bodyFormData.append("comment", this.comment);

            await bodyFormData.append(
                "DateComments",
                JSON.stringify(this.dateComments)
            );

            for (var i = 0; i < 5; i++) {
                if (this.ci[i] != null)
                    bodyFormData.append(`ci${i}`, this.ci[i]);
            }
            var config = {
                method: "post",
                headers: {
                    "Content-Type": "application/form-data;charset=utf-8",
                    "Access-Control-Allow-Origin": "*",
                    Accept: "*/*"
                },
                data: bodyFormData
            };
            await this.store.dispatch("addParticipant", config);
            window.location.reload();
        },
        add: function(id) {
            for (var i = 0; i < this.selectedDates.length; i++)
                if (this.selectedDates[i].id === id)
                    this.selectedDates[i].status = 1;
        },
        remove: function(id) {
            for (var i = 0; i < this.selectedDates.length; i++)
                if (this.selectedDates[i].id === id)
                    this.selectedDates[i].status = 0;
        },
        copyLink: function() {
            return this.shareLink;
        },
        alreadyReplied: function() {
            return this.participants.some(
                part => part.user_id == this.store.state.user.id
            );
        },
        datePassed: function() {
            if (this.schedule[0].reply_deadline == "no") return false;

            let date = new Date(Date.now());
            let replyDeadline = new Date(this.schedule[0].reply_deadline_date);
            return date > replyDeadline;
        },
        toDDMMYY(date) {
            let dated = new Date(date);
            return `${dated.getDate()}/${dated.getMonth() +
                1}/${dated.getFullYear()}`;
        },
        toMMHH(time) {
            return time.substring(0, 5);
        }
    }
};
</script>

<style scopped>
.btn1 {
    height: 5px;
    width: 10px;
}
</style>
